import { handleSendInquiry } from "../common";

const _contactUs04 = () => {
  initEvent();

  function initEvent() {
    handleSendInquiry({
      formId: ".contactUs-4 #contactUs-4-Form",
      trigger: ".contactUs-4 #contactUs-4-Submit",
    });
    $(".contactUs-4 .contactUs-4_faq .list > li article > header").on("click", function () {
      const content = $(this).siblings(".contactUs-4-des");
      if (content.length) {
        content.slideToggle(250);
      }
    });
  }
};

export default _contactUs04;